import React from "react";
import { Card, useTheme, Typography, Box } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import logo from "../../../assets/images/hashin256.png";
import { miliToGram, toPersianDigits, numberToTomans } from "../../../utils/helpers";
import Badge from "../BaseBadge/BaseBadge";
import { GOLD_BOX_STATUS } from "../../../utils/constants";
const ProductCard = ({ item }) => {
    const theme= useTheme();
    const getBadgeProps = (status) => {
        return { type: GOLD_BOX_STATUS[status].type, text: GOLD_BOX_STATUS[status].title }
    };

    const badgeProps = getBadgeProps(item.status);
    return (
        <Card
            sx={{
                width: 350,
                height: 200,
                borderRadius: 3,
                background: "linear-gradient(225deg, rgb(220, 235, 255), rgb(172, 200, 231))",
                color: theme.palette.text.default,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: 2,
                boxShadow: 5,
            }}
        >
            <Box 
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "12px",
                    width: "30%"
                }}
            >
                <img src={logo} alt="Logo" style={{ width: "50px", height: "50px" }} />
                <Typography variant="subtitle2">
                    {`وزن خالص: ${miliToGram(item.goldWeight)} گرم`}
                </Typography>
                <Typography variant="subtitle2">
                    {`عیار: ${toPersianDigits(750)}`}
                </Typography>
                <Typography variant="subtitle2">
                    {`سریال: ${toPersianDigits(item?.serialNumber || "*******")} `}
                </Typography>
            </Box>
            <Box 
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "8px",
                    width: "40%"
                }}
            >
                <Typography variant="caption">
                    پلمپ دیجیتال
                </Typography>
                <Box
                    sx={{
                        width: "80px",
                        height: "100px",
                        background: "linear-gradient(145deg,rgb(255, 218, 154),#ffcb74)",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#8B7500",
                        fontSize: "14px",
                        textAlign: "center",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                        textShadow: "1px 1px 0px rgba(255, 255, 255, 0.3), -1px -1px 0px rgba(0, 0, 0, 0.6)", // Engraved effect
                        border: "2px solid #B8860B",
                        fontFamily: `"Courier New", Courier, monospace`, // Gives a more industrial look
                    }}
                >
                    GOLD 750
                </Box>
            </Box>
            <Box 
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    padding: "24px 0",
                    alignItems: "center",
                    gap: "8px",
                    width: "30%"
                }}
            >
                <Typography variant="subtitle" color="textPrimary">
                    {`${numberToTomans(item.value)} تومان`}
                </Typography>
                <Badge {...badgeProps} />
                <LockIcon
                    sx={{ 
                        fontSize: 40,
                        color: theme.palette.background.gray
                    }} 
                />
            </Box>
        </Card>
    );
};

export default ProductCard;
